import { render, staticRenderFns } from "./manage-forfait.html?vue&type=template&id=1f296964&scoped=true&external"
import script from "./manage-forfait.js?vue&type=script&lang=js&external"
export * from "./manage-forfait.js?vue&type=script&lang=js&external"
import style0 from "./manage-forfait.scss?vue&type=style&index=0&id=1f296964&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f296964",
  null
  
)

export default component.exports